import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { LoadingButtonComponent } from '../loading-button/loading-button.component';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroXMark } from '@ng-icons/heroicons/outline';

@Component({
  selector: 'app-verification-modal',
  imports: [
    CommonModule,
    LoadingButtonComponent,
    NgIcon,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: './verification-modal.component.html',
  viewProviders: [provideIcons({ heroXMark })],
})
export class VerificationModalComponent implements OnInit {
  @Input() currentEmail!: string;

  @Output() resend = new EventEmitter<void>();
  @Output() completed = new EventEmitter<{ code: string }>();
  @Output() close = new EventEmitter<void>();

  formCode!: FormGroup;
  countdown: number = 60;
  canResend: boolean = false;
  isLoading: boolean = false;

  private interval: any;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const arr = this.fb.array([]);
    for (let i = 0; i < 6; i++) {
      arr.push(
        this.fb.control('', [
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9]$/),
        ])
      );
    }

    this.formCode = this.fb.group({ code: arr });
    this.startCountdown();
  }

  get codeControls() {
    return (this.formCode.get('code') as FormArray).controls;
  }

  onInput(event: Event, index: number) {
    const input = event.target as HTMLInputElement;
    if (input.value && index < this.codeControls.length - 1) {
      const next = document.getElementById(`code-${index + 1}`);
      next?.focus();
    }
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    if (
      event.key === 'Backspace' &&
      !this.codeControls[index].value &&
      index > 0
    ) {
      const prev = document.getElementById(`code-${index - 1}`);
      prev?.focus();
    }
  }

  submitCode() {
    if (this.formCode.invalid) {
      this.formCode.markAllAsTouched();
      return;
    }
    this.isLoading = true;
    const code = this.codeControls.map((c) => c.value).join('');
    this.completed.emit({ code });
  }

  resendCode() {
    this.canResend = false;
    this.countdown = 60;
    this.resend.emit();
    this.startCountdown();
  }

  private startCountdown() {
    clearInterval(this.interval);
    this.interval = setInterval(() => {
      if (this.countdown > 0) this.countdown--;
      else {
        this.canResend = true;
        clearInterval(this.interval);
      }
    }, 1000);
  }

  closeModal() {
    this.close.emit();
  }
}
